/*eslint-disable no-unused-vars*/
import React from 'react';
/*eslint-enable no-unused-vars*/

function removeSpacesFromText(text) {
  return text.replace(/ /g, '-');
}

export default removeSpacesFromText;
